import { api } from "../store/middleware/api";

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    addPaymentMethod: build.mutation({
      query: (body) => ({
        url: `/payment/add`,
        // url: "http://localhost:5055/api/payment/add",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Payment"]
    }),
    getPaymentMethod: build.query({
      query: () => ({
        url: `/payment/methods/all`,
      }),
      providesTags: ["Payment"],
    }),
    deletePaymentMethod: build.mutation({
      query: (body) => ({
        url: `/payment/delete`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Payment"]
    }),
    addPayment: build.mutation({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const transactionsRes = await fetchWithBQ({
          // url: "/api/payment/charge",
          url: "http://localhost:5055/api/payment/charge",
          method: "POST",
          body: _arg,
        });
        return transactionsRes;
      },
    })
  }),
  overrideExisting: false,
});

export const { useAddPaymentMethodMutation, useGetPaymentMethodQuery, useDeletePaymentMethodMutation, useAddPaymentMutation } = extendedApi;